import React from 'react';
import { TbLetterSpacing } from 'react-icons/tb';
import { t } from '@bay-email/core';
import { LetterSpacing } from '@extensions/AttributePanel/components/attributes/LetterSpacing';
import { pixelAdapter } from '@extensions/AttributePanel/components/adapter';
import { BlockAttributeTool } from './BlockAttributeTool';

export interface LetterSpacingToolProps {
	getPopupContainer: () => HTMLElement;
}

export function LetterSpacingTool({ getPopupContainer }: LetterSpacingToolProps) {
	return (
		<BlockAttributeTool
			title={t('Letter spacing')}
			icon={<TbLetterSpacing size={16} />}
			getPopupContainer={getPopupContainer}
		>
			<LetterSpacing
				label={t('Letter Spacing (px)')}
				config={pixelAdapter}
			/>
		</BlockAttributeTool>
	);
}
